import moment from 'moment-timezone';
import { IDaySchedule, IRawSchedule } from '../../models';

export function getTimestamps(hours: IRawSchedule[][]) : IDaySchedule {
  const dateStr = '1970-01-01';
  const dateStrNextDay = '1970-01-02';
  const dateFmt = 'YYYY-MM-DD HH:mm';
  const toScheduleRange = (rawSchedule: IRawSchedule[]) =>
    rawSchedule.length > 1
      ? {
        begin: moment.utc(`${dateStr} ${rawSchedule[0].hours}:${rawSchedule[0].minutes}`, dateFmt).valueOf(),
        end: moment.utc(`${rawSchedule[1].addOneDay ? dateStrNextDay : dateStr} ${rawSchedule[1].hours}:${rawSchedule[1].minutes}`, dateFmt).valueOf()
      }
      : null;
  return {
    first: hours.length > 0 ? toScheduleRange(hours[0]) : null,
    second: hours.length > 1 ? toScheduleRange(hours[1]) : null,
  };
}
